import * as React from "react";
import useApi from "hooks/use-api";
import {useCallback, useEffect, useState} from "react";
import {paths} from "paths";
import {enqueueSnackbar} from "notistack";
import {useNavigate, useParams} from "react-router-dom";
import Stack from "@mui/material/Stack";
import Plant from "benchmarking-domain/plant";
import {useOrganisation} from "../../../hooks/use-organisation";
import {PlantForm} from "../../../components/client/plants/plant-form";

const PlantFormMemo = React.memo(PlantForm);

export default function PlantDetails(): React.JSX.Element {

  const { plantId } = useParams();
  const { organisationId } = useOrganisation();
  const navigate = useNavigate();
  const { savePlant, subscribePlant } = useApi();
  const [plant, setPlant] = useState<Plant>();

  useEffect(() => {
    if (!organisationId || !plantId) {
      navigate(paths.errors.notFound, { replace: true});
      return;
    }

    const unsubscribePlant = subscribePlant(organisationId, plantId, (plant) => plant ? setPlant(plant) : navigate(paths.errors.notFound, { replace: true }));

    return () => {
      unsubscribePlant();
    }
  }, [navigate, plantId, subscribePlant, organisationId]);

  const submitPlantChanges = useCallback(async (data: Plant) => {
    try {
      await savePlant(organisationId!, {...data });
      enqueueSnackbar('Plant changed!', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Plant save failed! ' + error, { variant: 'error' });
    }

  }, [savePlant, organisationId])

  if(!plant)
    return <>Loading...</>;

  return <Stack spacing={3}>
    <PlantFormMemo plant={plant} onSubmit={submitPlantChanges} />
  </Stack>;
}
